import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { filtersAtom } from '@/atoms/filters/filter';
import { unwrappedSelectedFilterSetAtom } from '@/atoms/filters/userFilters';
import { filterAtomsToHydrateCallback } from '@/consts/atomHydration';
import { filterAtomDefaults } from '@/consts/defaults/filterAtomDefaults';
import { ConfigFilterKey } from '@/types/userConfigs';
import { useAutoApplyFilters } from './useAutoApplyFilters';

/**
 * Updates the selected filter atoms based on the content of the selected saved filter set.
 */
export const useLoadSelectedFilterSet = () => {
  const selectedFilterSet = useAtomValue(unwrappedSelectedFilterSetAtom);
  const setFilters = useSetAtom(filtersAtom);
  const autoApplyFilters = useAutoApplyFilters();

  useEffect(() => {
    if (selectedFilterSet) {
      const newFilterAtomValues = Object.entries(selectedFilterSet.definition.filters).reduce(
        (acc, [key, value]) => {
          const filterKey = key as ConfigFilterKey;

          const atomValueFn = filterAtomsToHydrateCallback[filterKey];

          if (!atomValueFn) {
            // eslint-disable-next-line no-console
            console.error(`Missing value function for filter key: ${filterKey}`);
            return acc;
          }

          const atomValueToSet = atomValueFn(value);

          return { ...acc, [key]: atomValueToSet };
        },
        { ...filterAtomDefaults },
      );

      setFilters(newFilterAtomValues);

      autoApplyFilters();
    }
  }, [selectedFilterSet?.configId]);
};
